const SELECTABLE_TYPES = {
    "ATTRIBUTE" : "+ Add Attribute",
    "BRAND" : "Brand",
    "BRAND_ID" : "brand_id",
    "CATEGORY" : "categories",
    "CATEGORY_ID" : "category_ids",
    "CHANNEL" : "channels",
    "CONCRETE_ENTITY": "concrete_entities",
    "RELATED_CONCRETE_ENTITY": "related_concrete_entities",
    "WORKFLOWS": 'workflows'
};

const IS_EMPTY = "is empty";
const IS_NOT_EMPTY = "is not empty";

export default {
  selectableTypes: SELECTABLE_TYPES,
  IS_EMPTY,
  IS_NOT_EMPTY
}